import {Button as AntButton} from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {noop, omit} from 'lodash';
import {IconLoadingQuarterCircleSolid} from '@baidu/ee-icon/svg';
import styles from './index.less';

const getClassNames = ({size, type, theme, className}) => classNames(
    styles.button,
    styles[`size-${size}`],
    styles[`type-${type}`],
    {
        [styles[`theme-${theme}`]]: type !== 'tint'
    },
    className
);

const ETUIButton = props => {
    const {icon, children, href, ...otherProps} = props;

    let antProps = omit(otherProps, ['size', 'type', 'theme', 'className', 'ghost', 'shape']);

    if (href) {
        antProps = {...antProps, href};
    }

    return (
        <AntButton
            className={getClassNames(props)}
            {...antProps}
        >
            {antProps.loading ? <IconLoadingQuarterCircleSolid className={styles.iconLoading} /> : icon}
            {children}
        </AntButton>
    );
};

Object.assign(ETUIButton, AntButton);

ETUIButton.propTypes = {
    size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
    type: PropTypes.oneOf(['solid', 'default', 'tint', 'vivid']),
    theme: PropTypes.oneOf(['primary', 'dark', 'highlight', 'info', 'success', 'warning', 'danger']),
    htmlType: PropTypes.string,
    icon: PropTypes.element,
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    disabled: PropTypes.bool,
    target: PropTypes.string,
    onClick: PropTypes.func,
    href: PropTypes.string
};

ETUIButton.defaultProps = {
    size: 'm',
    type: 'default',
    theme: 'primary',
    htmlType: undefined,
    icon: null,
    loading: false,
    disabled: false,
    target: undefined,
    onClick: noop,
    href: ''
};

export default ETUIButton;
